/**
 * Finnish label for the insurance-number row.
 *
 * The label is byte-identical across every consumer (the prototype's
 * UI labels every "Vakuutusnumero X" row with the same string), so it
 * is pinned here once rather than re-declared at each call site. A
 * future locale lift would route through `copy.ts`; for Phase A the
 * single Finnish label is pinned in code.
 */
export const INSURANCE_NUMBER_LABEL = 'Vakuutusnumero';
